import DownloadPdfButton from "./downloadPdfButton";

export default DownloadPdfButton;



// WEBPACK FOOTER //
// ./src/components/common/buttons/downloadPdfButton/index.js